import { commaListSchema, filterDateRangeSchema } from "@birdwatch/common";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { TaskList } from "@/features/office/tasks/list";
import {
  filterSearchFragment,
  notificationSearchFragment,
  withOperators,
} from "@/features/shared/filters-new";
import { maskSearchFragment } from "@/features/shared/route-masking";

const querySchema = z.object({
  search: z.string().optional(),
  savedView: z.string().optional(),
  ...filterSearchFragment,
  filters: z
    .object({
      status: withOperators(z.string().optional()),
      assigneeIds: withOperators(commaListSchema),
      dateRange: filterDateRangeSchema,
      placeIds: withOperators(commaListSchema),
      accountIds: withOperators(commaListSchema),
      creatorIds: withOperators(commaListSchema),
      locations: withOperators(z.string().optional()),
      ...notificationSearchFragment,
    })
    .optional(),
  "task-id": z.string().optional(),
  "group-by": z.string().optional(),
  ...maskSearchFragment,
});

export const routeId = "/office/tasks/";

export const Route = createFileRoute("/office/tasks/")({
  component: TaskList,
  validateSearch: querySchema,
});
